import { Component, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { PackageFacade } from '@app/store/package';
import { PackageAvailabilityType } from '@app/store/shared/models';
import { EntityListComponent, MediaImageComponent, UnavailableComponent } from '@shared/components';
import { DeleteButtonComponent } from './delete-button/delete-button.component';
import { getAvailabilityOptions } from '../list/config/availability-options';

@Component({
    selector: 'app-package-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [TranslateModule, ButtonModule, TagModule, EntityListComponent, MediaImageComponent, UnavailableComponent, DeleteButtonComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly packageFacade = inject(PackageFacade);
    private readonly translateService = inject(TranslateService);

    readonly package = this.packageFacade.package;
    readonly loading = this.packageFacade.loading;
    readonly saving = this.packageFacade.saving;
    readonly error = this.packageFacade.error;

    private readonly availabilityOptions = getAvailabilityOptions(this.translateService);

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.packageFacade.getPackage(id);
        }
    }

    ngOnDestroy(): void {
        this.packageFacade.clear();
    }

    availabilityLabel(type: PackageAvailabilityType): string {
        return this.availabilityOptions.find((option) => option.value === type)?.label ?? type;
    }

    onEdit(id: string): void {
        this.router.navigate([{ outlets: { modal: ['packages', 'edit', id] } }]);
    }

    onArchiveToggle(id: string, archived: boolean): void {
        if (archived) {
            this.packageFacade.unarchivePackage(id);
        } else {
            this.packageFacade.archivePackage(id);
        }
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
